import { AppConfig } from './app';

export type IdProvider = {
  idp: string;
  url: string;
};

export type GandalfUser = {
  vibeId: string;
  hatId: string;
  providerName: string;
  name?: string;
  eulaStatus?: string;
};

export type PostAuthComponentParams = {
  user: GandalfUser;
  onContinue: () => void;
  onCancel: () => void;
  config: AppConfig;
};

export enum AmplifyAuthEvent {
  signIn = 'signIn',
  cognitoHostedUI = 'cognitoHostedUI',
  customOAuthState = 'customOAuthState',
  signOut = 'signOut',
  signIn_failure = 'signIn_failure',
  cognitoHostedUI_failure = 'cognitoHostedUI_failure',
  customState_failure = 'customState_failure',
}
